"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _http_request = _interopRequireDefault(require("../../gateway/http_request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var EpubService = (applicationToken, sessionToken) => {
  var {
    buildHeader,
    get
  } = (0, _http_request.default)(applicationToken, sessionToken);
  var getEpubFile = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (uuid) {
      var headers = {};
      var path = "/contents/api/v1/epubs/".concat(uuid);
      headers = buildHeader(headers);
      var response = yield get(path, null, headers);
      return response;
    });
    return function getEpubFile(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    getEpubFile
  };
};
var _default = exports.default = EpubService;